import React, { useId } from "react";
import Dialog from "../Dialog";
import type { Prefill } from "./LeadForm";
import LeadFormPanel, { LeadFormRequest } from "./LeadFormPanel";

export default function LeadFormDialog({
  request,
  onDraft,
  onClose,
}: {
  request: LeadFormRequest;
  onDraft?: (values: Prefill) => void;
  onClose: () => void;
}) {
  const headingId = useId();

  return (
    <Dialog labelledBy={headingId} width="tw-w-[min(64rem,calc(100vw-2rem))]" onClose={onClose}>
      <LeadFormPanel
        request={request}
        headingId={headingId}
        onDraft={onDraft}
        onDone={onClose}
        doneLabel="Done"
      />
    </Dialog>
  );
}
